export const FORTE_HOME = 'https://forte.io/';
export const FIANT_FAQ = ' https://support.fiant.io/support/home';
